export class CallCenterVendaMarca {
  constructor(
    public marca: string,
    public valor: number,
    public percentual: number
  ) { }
}
